export const safeSessionStorage = {
    getItem: (key: string) => (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined')
        ? sessionStorage.getItem(key)
        : null,

    setItem: (key: string, value: string) => {
        if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem(key, value)
        }
    },

    removeItem: (key: string) => {
        if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem(key)
        }
    }
}
